/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  TutorLicensingFeePerRateBreakdown,
  TutorLicensingFeePerRateBreakdownFromJSON,
  TutorLicensingFeePerRateBreakdownToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchLicensedDirectorBillingDetailsResponseTutors
 */
export interface FetchLicensedDirectorBillingDetailsResponseTutors {
  /**
   * Unique identifier for the tutor.
   * @type number
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  userKey?: number
  /**
   * The tutor's first name.
   * @type string
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  firstName: string
  /**
   * The tutor's last name.
   * @type string
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  lastName: string
  /**
   * Unique identifier for the tutor as an actor.
   * @type number
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  actorKey?: number
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  totalPaid: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  totalOwed: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  licensingDue: CashAmount
  /**
   *
   * @type {Array<TutorLicensingFeePerRateBreakdown>}
   * @memberof FetchLicensedDirectorBillingDetailsResponseTutors
   */
  breakdown: Array<TutorLicensingFeePerRateBreakdown>
}

export function FetchLicensedDirectorBillingDetailsResponseTutorsFromJSON(
  json: any
): FetchLicensedDirectorBillingDetailsResponseTutors {
  return FetchLicensedDirectorBillingDetailsResponseTutorsFromJSONTyped(
    json,
    false
  )
}

export function FetchLicensedDirectorBillingDetailsResponseTutorsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLicensedDirectorBillingDetailsResponseTutors {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    firstName: json['firstName'],
    lastName: json['lastName'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
    totalPaid: CashAmountFromJSON(json['totalPaid']),
    totalOwed: CashAmountFromJSON(json['totalOwed']),
    licensingDue: CashAmountFromJSON(json['licensingDue']),
    breakdown: (json['breakdown'] as Array<any>).map(
      TutorLicensingFeePerRateBreakdownFromJSON
    ),
  }
}

export function FetchLicensedDirectorBillingDetailsResponseTutorsToJSON(
  value?: FetchLicensedDirectorBillingDetailsResponseTutors | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userKey: value.userKey,
    firstName: value.firstName,
    lastName: value.lastName,
    actorKey: value.actorKey,
    totalPaid: CashAmountToJSON(value.totalPaid),
    totalOwed: CashAmountToJSON(value.totalOwed),
    licensingDue: CashAmountToJSON(value.licensingDue),
    breakdown: (value.breakdown as Array<any>).map(
      TutorLicensingFeePerRateBreakdownToJSON
    ),
  }
}
